// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__3E1Dr","information":"Avatar_information__1Quyt","icon":"Avatar_icon__1xHRR","email":"Avatar_email__1qi4E","user":"Avatar_user__3igKH"};